import * as React from 'react';
import { DATAKATALOG_STATISTICS_INFO, DatakatalogMode } from './constants';
import InfoBox from '@/components/common/InfoBox';
import type { DatakatalogWindowLauncher } from './standaloneChannel';

interface OverlayButtonsProps {
    mode: DatakatalogMode;
    setMode?: (mode: DatakatalogMode) => void;
    setShouldReset: (shouldReset: boolean) => void;
    onClose: () => void;
    showReset: boolean;
    overlayRef: React.RefObject<HTMLDivElement | null>;
    standaloneTab: DatakatalogWindowLauncher & { pending: boolean };
}

export const OverlayButtons = ({
    mode,
    setMode,
    setShouldReset,
    onClose,
    showReset,
    overlayRef,
    standaloneTab,
}: OverlayButtonsProps) => {
    const handleSizeToggle = () => {
        if (setMode) {
            setMode(
                mode === DatakatalogMode.BIG ? DatakatalogMode.SMALL : DatakatalogMode.BIG
            );
        }
    };

    const handleResetSize = () => {
        if (overlayRef.current) {
            ['width', 'height', 'left', 'right', 'top', 'bottom'].forEach(prop =>
                overlayRef.current!.style.setProperty(prop, '')
            );
        }
    };

    return (
        <div className="datakatalog-overlay__buttons">
            <InfoBox
                className="datakatalog-overlay__info-box"
                triggerAriaLabel="Vis forklaring av datakatalogstatistikk"
            >
                {DATAKATALOG_STATISTICS_INFO}
            </InfoBox>
            {showReset && (
                <button
                    className="datakatalog-overlay__button"
                    aria-label="Tilbakestill størrelse"
                    title="Tilbakestill størrelse"
                    onClick={handleResetSize}
                >
                    <i
                        className="material-icons datakatalog-overlay__icon"
                        aria-hidden="true"
                    >
                        refresh
                    </i>
                </button>
            )}
            <button
                className="datakatalog-overlay__button"
                aria-label={mode === DatakatalogMode.BIG ? 'Gjør mindre' : 'Gjør større'}
                title={mode === DatakatalogMode.BIG ? 'Gjør mindre' : 'Gjør større'}
                onClick={handleSizeToggle}
            >
                <i
                    className="material-icons datakatalog-overlay__icon"
                    aria-hidden="true"
                >
                    {mode === DatakatalogMode.BIG ? 'chevron_right' : 'chevron_left'}
                </i>
            </button>
            <button
                className="datakatalog-overlay__button"
                aria-label="Gå til startsiden"
                title="Gå til startsiden"
                onClick={() => setShouldReset(true)}
            >
                <i
                    className="material-icons datakatalog-overlay__icon"
                    aria-hidden="true"
                >
                    home
                </i>
            </button>
            {standaloneTab.pending ? (
                <button
                    className="datakatalog-overlay__button"
                    aria-label={standaloneTab.pendingLabel}
                    title={standaloneTab.pendingLabel}
                    disabled
                >
                    <i
                        className="material-icons datakatalog-overlay__icon"
                        aria-hidden="true"
                    >
                        open_in_new
                    </i>
                </button>
            ) : standaloneTab.asLink ? (
                <a
                    className="datakatalog-overlay__button"
                    aria-label={standaloneTab.label}
                    title={standaloneTab.label}
                    href={standaloneTab.url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={standaloneTab.onOpen}
                >
                    <i
                        className="material-icons datakatalog-overlay__icon"
                        aria-hidden="true"
                    >
                        open_in_new
                    </i>
                </a>
            ) : (
                <button
                    className="datakatalog-overlay__button"
                    aria-label={standaloneTab.label}
                    title={standaloneTab.label}
                    onClick={standaloneTab.onOpen}
                >
                    <i
                        className="material-icons datakatalog-overlay__icon"
                        aria-hidden="true"
                    >
                        open_in_new
                    </i>
                </button>
            )}
            <button
                className="datakatalog-overlay__button"
                aria-label="Lukk datakatalogen"
                title="Lukk datakatalogen"
                onClick={onClose}
            >
                <i
                    className="material-icons datakatalog-overlay__icon"
                    aria-hidden="true"
                >
                    close
                </i>
            </button>
        </div>
    );
};
